import {CommonModule} from "@angular/common";
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from "moment";


@Pipe({ name: 'timeInMDH' })
export class TimeInMonthsDaysHours implements PipeTransform {
  /** * * @param value * @returns {string} */
  transform(value: any): string {
    if (value) {
      // var miliseconds = (moment().diff(moment(data[0].tidAttachTime), 'seconds')) * 1000;
      // const start = new Date(data[0].tidAttachTime);
      // const end = new Date(data[0].tidRetrievedTime);
      // const diffMs = end.getTime() - start.getTime();
      const diffDays = Math.floor(value / (1000 * 60 * 60 * 24));
      const diffMonths = Math.floor(diffDays / 30.44);  
      const remainingDays = Math.floor(diffDays % 30.44);
      const diffHours = Math.floor((value % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      return `${diffMonths}m ${remainingDays}d ${diffHours}h`;
    }
    else {
      return "NA";
    }
  }

}